import {Modal, Button} from 'components/ui';
import {useMobile} from 'utils/hooks';
import styles from './FocusModeReturnModal.module.scss';

interface FocusModeReturnModalProps {
  focusModeClosedCount: number;
  onContinue: () => void;
}

function ordinalFeminine(n: number): string {
  return `${n}ª`;
}

function FocusModeReturnModal({
  focusModeClosedCount,
  onContinue,
}: FocusModeReturnModalProps): JSX.Element {
  const {isMobile} = useMobile();

  return (
    <Modal
      isOpen
      onClose={onContinue}
      clickOutsideToClose={false}
      buttonClose={false}
      minWidth={isMobile ? undefined : 500}
      maxWidth={isMobile ? 360 : 500}
      vw={isMobile ? 94 : 90}
    >
      <div className={styles.container}>
        <p className={styles.message}>
          Sua saída da plataforma foi registrada.
          <br />
          Esta foi a sua{' '}
          <strong>{ordinalFeminine(focusModeClosedCount)} saída</strong> de no
          máximo 10.
          <br />
          Lembre-se: você tem até 10 minutos para retornar. Se ultrapassar esse
          limite ou atingir 10 saídas, a atividade é encerrada e os dados não
          são enviados.
        </p>
        <div className={styles.action}>
          <Button text="Continuar" variant="primary" onClick={onContinue} />
        </div>
      </div>
    </Modal>
  );
}

export default FocusModeReturnModal;
